import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./config/store";
import {
  Grommet,
  Box,
  Spinner,
  grommet,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import "./index.css";
import LoginSet from "./App";
import Home from "./Components/Home";
import reportWebVitals from "./reportWebVitals";
import FirstTimeUser from "./Components/FirstTimeUser";
import LoginCustomer from "./LoginCustomer";
import CustomerRegistration from "./Components/CustomerRegistration";
import LoginCustomerForgotPasswd from "./Components/LoginCustomerForgotPasswd";
import TaxonomyL1 from "./Components/TaxonomyL1";
import TaxonomyL2 from "./Components/TaxonomyL2";
import T1T2Products from "./Components/T1T2Products";
import ListView from "./Components/ListView";
//import ListViewLivedemoDetail from "./Components/ListView-livedemoDetail";
/* import ListViewVideoDetail from "./Components/MMContentDetail";
import ListViewDocumentDetail from "./Components/ListView-DocumentDetail"; */
import LaunchLiveDemo from "./Components/LaunchLiveDemo";
import ScheduleLiveDemo from "./Components/ScheduleLiveDemo";
import UserdashboardUpcomingDemos from "./Components/UserdashboardUpcomingDemos";
import UserInfo from "./Components/UserInfo";
import GetHelp from "./Components/GetHelp";
import "@blueprintjs/core/lib/css/blueprint.css";

ReactDOM.render(
  <Provider store={store}>
    <Grommet full theme={theme}>
      <Router>
        <Switch>
          <Route exact path="/" component={LoginSet} />
          <Route path="/login" component={LoginSet} />
          <Route path="/search" component={LoginSet} />
          <Route path="/home" component={Home} />
          <Route path="/t1t2products" component={T1T2Products} />
          <Route path="/:taxonomyl1/:taxonomyl2" component={TaxonomyL2} />
          <Route path="/:taxonomyl1" component={TaxonomyL1} />
          <Route path="/register" component={FirstTimeUser} />
          <Route path="/customerlogin" component={LoginCustomer} />
          <Route
            path="/customerregistartion"
            component={CustomerRegistration}
          />
          <Route
            path="/logincustomerforgotpasswd"
            component={LoginCustomerForgotPasswd}
          />
          <Route path="/listview" component={ListView} />
          {/*           <Route
            path="/listview-livedemodetail"
            component={ListViewLivedemoDetail}
          /> */}
          {/* <Route path="/listview-videodetail" component={ListViewVideoDetail} /> */}
          {/*           <Route
            path="/listview-documentdetail"
            component={ListViewDocumentDetail}
          /> */}
          <Route path="/launch-live-demo" component={LaunchLiveDemo} />
          <Route path="/schedule-live-demo" component={ScheduleLiveDemo} />
          <Route
            path="/userdashboard-upcoming-demos"
            component={UserdashboardUpcomingDemos}
          />
          {/* <Route path="/userinfo" component={UserInfo} /> */}
          {/* <Route path="/gethelp" component={GetHelp} /> */}
          <Route path="/firsttimeuser" component={FirstTimeUser} />
        </Switch>
      </Router>
    </Grommet>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
